export default __webpack_public_path__ + "static/media/selectedroomicon2.3f35d47d.svg";